import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelS, LabelXS } from '@sorare/core/src/atoms/typography';

import { ItemOwnerSince } from 'components/ItemPreview/ItemOwnerSince';
import { FlexCard } from 'components/token/FlexCard';

import type { OwnedCardRow_anyCard } from './__generated__/index.graphql';

const FlexCardWrapper = styled.div`
  width: 28px;
`;

const CardItem = styled(Horizontal)`
  justify-content: space-between;
  min-height: 40px;
`;

const CardInfo = styled(Vertical).attrs({
  gap: 0,
})`
  justify-content: center;
  flex-grow: 1;
`;

type Props = {
  anyCard: Nullable<OwnedCardRow_anyCard>;
};
export const OwnedCardRow = ({ anyCard }: Props) => (
  <CardItem>
    <Horizontal>
      <FlexCardWrapper>
        {anyCard && <FlexCard card={anyCard} width={40} withLink />}
      </FlexCardWrapper>
      <CardInfo>
        <LabelS as="span">{anyCard?.anyPlayer?.displayName}</LabelS>
        <LabelXS color="var(--c-nd-700)" as="span">
          {anyCard?.serialNumber}/{anyCard?.supply}
        </LabelXS>
        <LabelXS color="var(--c-nd-400)" as="span">
          {anyCard?.displayRarity}
        </LabelXS>
      </CardInfo>
    </Horizontal>
    {anyCard && <ItemOwnerSince card={anyCard} />}
  </CardItem>
);

OwnedCardRow.fragments = {
  anyCard: gql`
    fragment OwnedCardRow_anyCard on AnyCardInterface {
      slug
      serialNumber
      supply
      displayRarity
      anyPlayer {
        slug
        displayName
      }
      ...FlexCard_anyCard
      ...ItemOwnerSince_anyCard
    }
    ${FlexCard.fragments.anyCard}
    ${ItemOwnerSince.fragments.anyCard}
  ` as TypedDocumentNode<OwnedCardRow_anyCard>,
};
